import {
  useAccountMutating,
  useCheckout,
  useIsTrialAccount,
} from '@/modules/account'
import {
  PlanCards,
  PlansSelector,
  SubmitPlan,
  TermsCheckbox,
  useFetchPlans,
} from '@/modules/auth'
import { useForm } from '@/stores'

export const SelectPlanForm = () => {
  useFetchPlans()
  const isTrial = useIsTrialAccount()
  const { selectPlan } = useCheckout()
  const isMutating = useAccountMutating()
  const { data, errors, setFieldValue, setFieldError } = useForm()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()

    if (!data?.priceId) {
      setFieldError('priceId', 'Plan is required')
      return
    }

    selectPlan(data.priceId as string)
  }

  if (isTrial) return <PlanCards />

  return (
    <form
      onSubmit={handleSubmit}
      className="space-y-4 sm:space-y-4 md:space-y-5"
    >
      <PlansSelector
        value={data?.priceId as string}
        error={errors?.priceId}
        setFieldValue={setFieldValue}
      />

      <TermsCheckbox
        value={data?.terms as boolean}
        setFieldValue={setFieldValue}
        className="pt-2"
        isMutating={isMutating}
      />

      <SubmitPlan
        agreedToTerms={data?.terms as boolean}
        isMutating={isMutating}
        loadingText="Redirecting to checkout..."
      >
        Continue to checkout
      </SubmitPlan>
    </form>
  )
}
